import Joi from 'joi';

export const CreateLibraryValidation = Joi.object({
  title: Joi.string().min(1).required().messages({
    'string.min': 'Library name is required.',
    'any.required': 'Library name is required.',
  }),
  labels: Joi.array().min(1).required().messages({
    'array.min': 'Select at least one label.',
    'any.required': 'Select at least one label.',
  }),
});
